import React from 'react';
import {Field, useFormState} from 'react-final-form';
import {FormFieldRadioGroup} from '@yandex-data-ui/cloud-components';

import {I18nKFunction} from 'i18n';
import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import ClosableSection from 'components/calculator/ClosableSection/ClosableSection';
import {ComputeFormFieldsValues} from 'components/calculator/ComputeFormFields/ComputeFormFields';
import {getDiskSizeProps} from 'components/calculator/ComputeFormFields/utils';
import {ComputeConfig} from 'components/calculator/models';
import {CALCULALTOR_QA_PREFIX} from 'components/calculator/PricesCalculator/PricesCalculator';
import {FormFieldRangeInputPicker} from 'components/formFields';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

const getDiskOptions = (i18nK: I18nKFunction) => [
    {content: i18nK('value_disk-network-hdd'), value: 'network-hdd'},
    {content: i18nK('value_disk-network-nvme'), value: 'network-nvme'},
];

interface ComputeFormDiskFieldsProps extends WithTranslationProps {
    name: string;
    index: number;
    onClose: () => void;
    osProducts: ComputeConfig['osProducts'];
    disableRepeatableDisks?: boolean;
}

const ComputeFormDiskFields: React.FC<ComputeFormDiskFieldsProps> = (props) => {
    const {name, index, disableRepeatableDisks, osProducts, onClose, i18nK, i18n} = props;
    const {
        values: {osProduct},
    } = useFormState<ComputeFormFieldsValues>();
    const diskOptions = getDiskOptions(i18nK);
    const isBoot = index === 0;

    let displayName = i18nK('label_disk-name', {index: index + 1});

    if (isBoot) {
        displayName = i18nK('label_boot-disk-name', {index: index + 1});
    }

    if (disableRepeatableDisks) {
        displayName = i18nK('label_single-disk-name');
    }

    return (
        <CalculatorFormLayout.Section key={index}>
            <ClosableSection
                showClose={!isBoot}
                onClose={onClose}
                dataQa={`${CALCULALTOR_QA_PREFIX}-closable-disk-section-${index + 1}`}
            >
                <CalculatorFormLayout.Row title={displayName}>
                    <Field name={`${name}.type`}>
                        {(fieldProps) => (
                            <FormFieldRadioGroup {...fieldProps} options={diskOptions} size="l" />
                        )}
                    </Field>
                </CalculatorFormLayout.Row>
                <CalculatorFormLayout.Row
                    title={i18nK('field_disk-size')}
                    note={i18nK('context_disk-size')}
                >
                    <Field name={`${name}.size`}>
                        {(fieldProps) => (
                            <FormFieldRangeInputPicker
                                {...fieldProps}
                                size="l"
                                {...getDiskSizeProps({osProducts, osProduct, isBoot}, i18n)}
                            />
                        )}
                    </Field>
                </CalculatorFormLayout.Row>
            </ClosableSection>
        </CalculatorFormLayout.Section>
    );
};

export default withTranslation('calculator')(ComputeFormDiskFields);
